import { Button, ConfigProvider } from 'antd'
import { twMerge } from 'tailwind-merge'
import { colors } from '../../services/style'

export function SL_Button({ type = 'primary', variant, className, children, disabled, ...rest }) {
    function getTokens() {
        let tokenVariant = {}
        switch (variant) {
            case 'secondary': {
                tokenVariant = {
                    colorPrimary: colors.primary[500],
                }
                break
            }

            case 'close': {
                tokenVariant = {
                    colorPrimary: colors['sl-gray'][400],
                }
                break
            }

            case 'danger': {
                tokenVariant = {
                    colorPrimary: colors['sl-red'][200],
                }
                break
            }
        }

        let tokenType = {}
        switch (type) {
            case 'default': {
                tokenType = {
                    colorText: colors.primary[500],
                    colorBgContainerDisabled: colors['sl-gray'][400],
                    colorTextDisabled: colors['sl-gray'][400],
                    colorIcon: colors['sl-gray'][400],
                    lineWidth: 0,
                    primaryShadow: '0 0 0',
                }
                break
            }

            case 'primary': {
                tokenType = {
                    colorBgContainerDisabled: colors['sl-gray'][200],
                    colorTextDisabled: colors['sl-gray'][400],
                    colorIcon: colors['sl-gray'][400],
                    lineWidth: 0,
                    primaryShadow: '0 0 0',
                }
                break
            }

            case 'link': {
                tokenType = {
                    colorLink: colors.primary[500],
                    colorLinkActive: colors.primary[500],
                    colorLinkHover: colors.primary[100],
                    lineWidth: 0,
                    primaryShadow: '0 0 0',
                }
                break
            }
        }

        return { ...tokenVariant, ...tokenType }
    }

    const classes = twMerge(`
        flex
        justify-center
        items-center
        ${className}
    `)

    return (
        <ConfigProvider
            theme={{
                token: getTokens(),
            }}
        >
            <Button type={type} {...rest} className={`${classes} ${disabled && 'bg-sl-transparency-1 hover:bg-sl-transparency-1 text-sl-gray-700 cursor-not-allowed border border-sl-gray-700'}`} disabled={disabled}>
                {children}
            </Button>
        </ConfigProvider>
    )
}
